import React from "react"
import { Row, Col, Card, CardBody, CardTitle, Container } from "reactstrap"
import HighchartsReact from "highcharts-react-official"
import Highcharts from "highcharts"

function ExtraAvgHighChart({ data }) {
  // const chartData = [
  //     { date: "2025-02-21", highScore: 30, avgScore: 10 },
  //     { date: "2025-02-22", highScore: 62, avgScore: 46 },
  //     { date: "2025-02-23", highScore: 115, avgScore: 85 },
  //     { date: "2025-02-24", highScore: 95, avgScore: 68 },
  //     { date: "2025-02-25", highScore: 125, avgScore: 115 },
  //     { date: "2025-02-26", highScore: 165, avgScore: 110 },
  //     { date: "2025-02-27", highScore: 155, avgScore: 70 },
  //     { date: "2025-02-28", highScore: 122, avgScore: 87 },
  //     { date: "2025-02-29", highScore: 101, avgScore: 71 },
  //     { date: "2025-02-30", highScore: 95, avgScore: 50 },

  //   ]

  const labels = data.map(item => item.date)
  const highScore = data.map(item => item.highScore)
  const avgScore = data.map(item => item.avgScore)
  const nop = data.map(item => item.nop)
  const noOfJoinVirtualUser = data.map(item => item.noOfJoinVirtualUser)

  const chartOptions = {
    chart: {
      zooming: {
        type: "xy",
      },
    },
    title: {
      text: "Control Score",
    },
  
    xAxis: {
      categories: labels,
      crosshair: true,
    },
    yAxis: [
      {
        // Primary Y Axis
        labels: {
          format: "{value}",
          style: { color: "#2196F3" },
        },
        title: {
          text: "Scores",
          style: { color: "#2196F3" },
        },
      },
      {
        
        // Secondary Y Axis
        title: {
          text: "Virtual / Participants",
          style: { color: "#6ac819" },
        },
        labels: {
          format: "{value}",
          style: { color: "#6ac819" },
        },
        opposite: true,
      },
    ],
    tooltip: {
      shared: true,
    },
    legend: {
      layout: "vertical",
      align: "left",
      x: 80,
      verticalAlign: "top",
      y: 55,
      floating: true,
      backgroundColor:
        Highcharts.defaultOptions.legend.backgroundColor ||
        "rgba(255,255,255,0.25)",
    },
    series: [
      {
        name: "High Score",
        type: "spline",
        data: highScore,
        color: "#2196F3",
        tooltip: { valueSuffix: "" },
        yAxis: 0,
      },
      {
        name: "Average Score",
        type: "spline",
        data: avgScore,
        color: "#dd0da5",
        tooltip: { valueSuffix: "" },
        yAxis: 0,
      },
      {
        name: "Virtual Users",
        type: "column",
        data:noOfJoinVirtualUser, 
        color: "rgba(240, 49, 24, 0.61)",
        yAxis: 1,
        tooltip: { valueSuffix: "" },
      },
      {
        name: "Participants",
        type: "column",
        data: nop,
        color: "rgba(54, 224, 102, 0.66)",
        yAxis: 1,
        tooltip: { valueSuffix: "" },
      },
    ],
  }
  // console.log("data from crowd chart", data)
  return (
    <div>
      <div className="border border-gray-300 rounded-lg ">
        <Card>
          <CardBody>
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export default ExtraAvgHighChart
